import z from 'zod';
export const createDepartmentSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255).describe('Required for create'),
    code: z.string().min(1, 'Code is required').max(255).describe('Required for create'),
    description: z.string().optional().nullable(),
    parentDepartmentId: z.number().optional().nullable(),
    isActive: z.boolean().optional(),
});
export const updateDepartmentSchema = createDepartmentSchema;
